import {createSelector} from '@reduxjs/toolkit';

import {TAppState} from '../../config/types';
import {DOCUMENT_UPLOAD_TEMPLATE_SLICE} from './document-upload-template-slice-constants';

const selectDocumentUploadTemplateSliceState = (state: TAppState) => state[DOCUMENT_UPLOAD_TEMPLATE_SLICE];

export const selectDocumentUploadTemplateData = createSelector(
    selectDocumentUploadTemplateSliceState,
    state => state?.documentUploadTemplateData,
);

export const selectSettingTemplateTargetColumns = createSelector(
    selectDocumentUploadTemplateSliceState,
    state => state?.settingTemplateTransferTargetColumns,
);
